
























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import DataTableAttempts from '@/app/shared/components/data-tables/attempts.vue';
import ContentPaymentInfo from '@/app/shared/components/contents/payment-info.vue';
@Component({ components: { DataTableAttempts, ContentPaymentInfo } })
export default class DialogInstallmentDetailsComponent extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  private get refs() {
    return refsService;
  }
  private get installment() {
    return this.refs.modules.contract.installment;
  }
  private get installmentPaymentInfo() {
    return (
      this.refs.modules.contract.installment.PaymentInfos?.find(
        (x) => x.StatusChargePaymentMethod
      ) || this.refs.modules.contract.installmentPaymentInfo
    );
  }
}
